import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { VendorDenialReason } from '../../../models/vendor-denial-reason.enum';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

interface VendorDenialForm {
  reason: FormControl<string | null>;
  otherReason: FormControl<string | null>;
}

@Component({
  selector: 'app-vendor-denial-reason-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioButton,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './vendor-denial-reason-dialog.component.html',
  styleUrl: './vendor-denial-reason-dialog.component.scss',
})
export class VendorDenialReasonDialogComponent {
  VendorDenialReason = VendorDenialReason;

  vendorDenialForm = new FormGroup<VendorDenialForm>({
    reason: new FormControl('', [Validators.required]),
    otherReason: new FormControl(''),
  });

  get reasonOptions(): VendorDenialReason[] {
    return Object.entries(VendorDenialReason).map(r => r[1]);
  }

  get otherReason(): boolean {
    return (
      this.vendorDenialForm.controls.reason.value == VendorDenialReason.Other
    );
  }

  get reasonProvided(): boolean {
    return (
      this.otherReason 
        ? this.vendorDenialForm.controls.otherReason.value !== null && this.vendorDenialForm.controls.otherReason.value !== ''
        : this.vendorDenialForm.controls.reason.value !== null && this.vendorDenialForm.controls.reason.value !== ''
    )
  }

  constructor(
    private dialog: MatDialogRef<VendorDenialReasonDialogComponent>
  ) {}

  onCancel() {
    this.dialog.close();
  }

  onDeny() {
    let reason = this.vendorDenialForm.controls.reason.value;

    if (this.otherReason) {
      const otherValue = this.vendorDenialForm.controls.otherReason.value;
      reason = otherValue;
    }

    this.dialog.close(reason);
  }
}
